import { registerCardTemplate } from "../../../common/common";
import { lazyTemplate } from "../../lazyTemplate";

// Eager metadata registration; the render component (CardListWidget) code-splits
// into its own tpl-card-list chunk, loaded on demand when the widget renders.
registerCardTemplate({
    id: 'card-list',
    template: lazyTemplate(() => import(/* webpackChunkName: "tpl-card-list" */ "./CardListTemplate")),
    name: 'Card List',
    description: 'Scrollable Card List',
    complexity: 'easy',
    layout: {
        w: 9,
        h: 8
    },
    canDragDropFields: true
});
